import { createWebHistory, createRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";

import mainView from "./mainView.vue";
import privacyPolicy from "./privacyPolicy.vue";
import termsOfService from "./termsOfService.vue";
import proximamenteScreen from "./proximamenteScreen.vue";
import adminScreen from "./adminScreen.vue";
import pagoExitosoScreen from "./pagoExitosoScreen.vue";
import suscribirseScreen from "./suscribirseScreen.vue";
import publicQuestionsScreen from "./publicQuestionsScreen.vue";
import publicQuestionScreen from "./publicQuestionScreen.vue";
import caidoView from "./caidoView.vue";
import yateScreen from "./yateScreen.vue";
import redaccionScreen from "./redaccionScreen.vue";
import profileScreen from "./profileScreen.vue";
import loginView from "./loginView.vue";

export const ESCONDIDO = false;
// process.env.VUE_APP_ENV == "development" ? false : true;

export const CAIDO = false;

const main_route = CAIDO
  ? { path: "/", component: caidoView, name: "main-view" }
  : !ESCONDIDO
  ? {
      path: "/",
      component: mainView,
      name: "main-view",
      meta: { requiresAuth: true },
    }
  : { path: "/", component: proximamenteScreen, name: "main-view" };

const hidden_route = { path: "/schacer", component: mainView, name: "hidden" };

const routes = [main_route];

if (!CAIDO) {
  routes.push(
    ...[
      {
        path: "/terms-of-service",
        component: termsOfService,
        name: "terms-of-service",
      },
      {
        path: "/privacy-policy",
        component: privacyPolicy,
        name: "privacy-policy",
      },
      { path: "/admin", component: adminScreen, name: "admin" },
      {
        path: "/suscribirse",
        component: suscribirseScreen,
        name: "suscribirse",
      },
      {
        path: "/pago-exitoso",
        component: pagoExitosoScreen,
        name: "pago-exitoso",
        props: (route) => ({ preapproval_id: route.query.preapproval_id }),
      },
      {
        path: "/preguntas-publicas",
        component: publicQuestionsScreen,
        name: "public-questions",
      },
      {
        path: "/preguntas-publicas/:question_id",
        component: publicQuestionScreen,
        name: "public-question",
        props: true,
      },
      {
        path: "/ya-me-suscribi/",
        component: yateScreen,
        name: "yate",
      },
      {
        path: "/modo-redaccion/",
        component: redaccionScreen,
        name: "modo-redaccion",
        meta: { requiresAuth: true, requiresPermission: "redaccion:data" },
      },
      {
        path: "/perfil/",
        component: profileScreen,
        name: "perfil",
        meta: { requiresAuth: true },
      },
      {
        path: "/login",
        component: loginView,
        name: "login",
      },
    ]
  );
}

if (ESCONDIDO) {
  routes.push(hidden_route);
}

routes.push(
  { path: "/:pathMatch(.*)*", redirect: "/" } // Capturaba TODO
);

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const { isAuthenticated, checkAuth, restoreFromLocalStorage, user } =
    useAuth();

  // Si la ruta no requiere autenticación, permitir acceso
  if (!to.meta.requiresAuth) {
    // Si está yendo al login y ya está autenticado, redirigir al main
    if (to.name === "login" && isAuthenticated.value) {
      next({ name: "main-view" });
      return;
    }
    next();
    return;
  }

  // Para rutas que requieren autenticación:

  // Primero intentar restaurar desde localStorage
  if (!isAuthenticated.value) {
    const restored = restoreFromLocalStorage();

    // Si se restauró, verificar que las credenciales sigan siendo válidas
    if (restored) {
      const isValid = await checkAuth();
      if (!isValid) {
        next({ name: "login" });
        return;
      }
    } else {
      // No hay datos locales, redirigir al login
      next({ name: "login" });
      return;
    }
  }

  // Verificar permisos específicos si es necesario
  if (to.meta.requiresPermission) {
    const hasPermission = user.permissions.includes(to.meta.requiresPermission);
    if (!hasPermission) {
      next({ name: "main-view" });
      return;
    }
  }

  next();
});

export default router;
